/**
 * Paths for each SidebarNav `data-section` / bot `navigate-<section>` slug.
 * Keep in sync with bot/dashboardPageCopy.js SECTION_SCRIPTS_BY_SLUG keys.
 */
export const DASHBOARD_BOT_SECTION_PATH = {
  inbox: '/inbox',
  'all-conversations': '/conversations',
  mentions: '/conversations/mentions',
  unattended: '/conversations/unattended',
  'bonnie-faqs': '/bonnie/faqs',
  'bonnie-documents': '/bonnie/documents',
  contacts: '/contacts',
  dashboard: '/reports/overview',
  analytics: '/reports/conversations',
  'reports-agents': '/reports/agents',
  'campaigns-live': '/campaigns/live-chat',
  campaigns: '/campaigns',
  'help-articles': '/help/articles',
  'help-categories': '/help/categories',
  'help-locales': '/help/locales',
  settings: '/settings/account',
  'settings-agents': '/settings/agents',
  'settings-teams': '/settings/teams',
  'settings-inboxes': '/settings/inboxes',
  'settings-labels': '/settings/labels',
  'settings-automation': '/settings/automation',
  'settings-canned': '/settings/canned-responses',
  'settings-integrations': '/settings/integrations',
  'settings-audit': '/settings/audit-logs',
};

/** Socket bot-action → path (keys like `navigate-dashboard`). */
export const DASHBOARD_BOT_NAVIGATE_PATH = Object.fromEntries(
  Object.entries(DASHBOARD_BOT_SECTION_PATH).map(([section, path]) => [`navigate-${section}`, path]),
);

/**
 * Sidebar / bot slug for the current pathname (longest path wins).
 * Used to notify the LiveKit bot (`user-navigated`, `page-loaded`) in sync with dashboardPageCopy.js.
 */
export function sectionSlugForDashboardPath(pathname) {
  const path = (pathname || '').replace(/\/+$/, '') || '/';
  const sorted = Object.entries(DASHBOARD_BOT_SECTION_PATH).sort((a, b) => b[1].length - a[1].length);
  for (const [section, p] of sorted) {
    const base = p.replace(/\/+$/, '') || '/';
    if (path === base) return section;
  }
  return null;
}
